import {
  getLiveChatActions,
  getLiveChatLoadParams,
  getOpenedStatus,
} from 'plugin/live-chat/selector/liveChatSelectors';
import {
  LIVE_CHAT_UPDATE_OPENED_STATUS,
  LIVE_CHAT_UPDATE_STATUS,
} from './liveChatActionTypes';
const debug = require('debug')('live-chat-actions');

export function updateStatus(status: string) {
  return {
    type: LIVE_CHAT_UPDATE_STATUS,
    status,
  };
}

export function updateOpenedStatus(status: string) {
  return {
    type: LIVE_CHAT_UPDATE_OPENED_STATUS,
    status,
  };
}

export type liveChatsActionsType = {
  load: () => void,
  kill: () => void,
  toggle: () => void,
  identify: () => void,
  update: () => void,
};

export const liveChatsActions: liveChatsActionsType = {
  load: (dispatch, getState) => {
    const options = getLiveChatLoadParams(getState(), dispatch);
    const { load } = getLiveChatActions(getState());
    debug('load', options);
    load(options);
  },
  kill: (dispatch, getState) => {
    const { kill } = getLiveChatActions(getState());
    debug('kill');
    kill();
  },
  toggle: (dispatch, getState) => {
    const openedStatus = getOpenedStatus(getState());
    const { toggle } = getLiveChatActions(getState());
    debug('toggle', openedStatus);
    toggle(openedStatus);
  },
  identify: (dispatch, getState) => {
    const options = getLiveChatLoadParams(getState(), dispatch);
    const { identify } = getLiveChatActions(getState());
    debug('identify', options);
    identify(options);
  },
  update: (dispatch, getState) => {
    const options = getLiveChatLoadParams(getState(), dispatch);
    const { update } = getLiveChatActions(getState());
    debug('update', options);
    update(options);
  },
};
